module.exports = __webpack_public_path__ + "static/img/10.23d3b74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/10.png
// module id = wRKs
// module chunks = 0